<form class="app-form" [formRoot]="form">
  <div id="contactDetails">
    <h4>{{ 'MESSAGES.INFOS.LETS_GET_STARTED' | translate }}</h4>
    <p>
      {{ 'MESSAGES.PROMPTS.ALREADY_HAVE_ACCOUNT' | translate }}<a
        class="ml-2 cursor-pointer"
        [routerLink]="'/auth/login'"
        >{{ 'LABELS.LOGIN' | translate }}</a
      >
    </p>
    @if(portal()?.isMerchant) {
    <p [innerHTML]="'LOGIN.PARA1.1' | translate"></p>
    <p [innerHTML]="'LOGIN.PARA2.1' | translate"></p>
    } @else {
    <span [innerHTML]="'LOGIN.PARA1.2' | translate"></span>
    <span [innerHTML]="'LOGIN.PARA2.2' | translate"></span>
    }
    <div class="form-group">
      <label class="col-form-label label-required">{{ 'LABELS.EMAIL_ADDRESS' | translate }}</label>
      <input
        class="form-control"
        type="email"
        [formField]="form.email"
        autocomplete="email"
        inputmode="email"
        placeholder="{{ 'MESSAGES.PROMPTS.ENTER_EMAIL_ADDRESS' | translate }}"
        appFormFieldOnError
        [customMessages]="{ required: 'MESSAGES.ERRORS.EMAIL_REQUIRED' | translate }"
      />
      <span class="text-muted block mt-1">{{ 'MESSAGES.PROMPTS.ENTER_EMAIL_ADDRESS_REQUIRES' | translate }}</span>
    </div>
    @if(portal()?.isMerchant) {
    <div class="form-group">
      <label class="col-form-label">{{ 'LABELS.PHONE_NUMBER' | translate }}</label>
      <div class="input-group">
        <app-phone-number-input
          [preferredCountries]="preferredCountries"
          [initialCountry]="'za'"
          [separateDialCode]="separateDialCode"
          name="phone"
          [formField]="form.mobileNumber"
        >
        </app-phone-number-input>
      </div>
      <span
        class="text-muted block mt-1"
        [innerHTML]="'MESSAGES.PROMPTS.ENTER_PHONE_NUMBER_MESSAGE' | translate"
      ></span>
    </div>
    }

    <div class="form-group mb-0 mt-6">
      <div class="checkbox p-0">
        <input id="confirmCheckbox" type="checkbox" [formField]="form.confirmCheckbox" />
        <label class="text-muted" for="confirmCheckbox"
          ><span class="w-full block" id="termsAndConditions"
            >{{ 'MESSAGES.PROMPTS.CONFIRM_READ_TERMS' | translate }}<button
              type="button"
              class="ml-1 cursor-pointer btn-bare text-primary [font:inherit] [letter-spacing:inherit]"
              (click)="openTermsAndConditions()"
            >
              {{ 'LABELS.TERMS' | translate }}</button
            >&nbsp;{{ 'LABELS.AND' | translate }}&nbsp;<a
              class="ml-1"
              href="https://www.halodot.io/legal/eula"
              target="_blank"
              >EULA&nbsp;</a
            ></span
          ></label
        >
      </div>
      <button
        class="btn btn-gradient btn-block mt-4"
        type="submit"
        [disabled]="form().invalid() || form().submitting()"
      >
        {{ 'LABELS.CONTINUE' | translate }}
      </button>
      <button class="btn btn-outline-dark btn-block mt-4" type="button" (click)="back.emit()">
        {{ 'LABELS.BACK' | translate }}
      </button>
    </div>
  </div>
</form>
